// Fallback and display constants for AssociatedStreams
export const UNKNOWN_SITE_NAME = "Unknown Site";
export const UNKNOWN_AREA_NAME = "Unknown Area";
export const AREA_NAME_FALLBACK = "Area Name";
export const NO_ASSOCIATED_STREAMS_MESSAGE = "No deployments available";
export const NO_DEPLOYMENTS_MESSAGE = "Deployments are not available for the selected appearance";
// Breadcrumb configuration
export const getBreadcrumbConfig = (objectName) => [
  {
    navigateTo: "/settings",
    breadcrumbText: "Settings"
  },
  {
    navigateTo: "/enrolledappearance",
    breadcrumbText: "Enrolled Appearances"
  },
  {
    navigateTo: null,
    breadcrumbText: objectName || "Associated Streams"
  }
];
